// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 10H22V12H21V20H22V22H16V15H8V22H2V20H3V12H2V10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10 22V17H14V22H10Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19 2H5V4H6V8H18V4H19V2ZM13.002 3.99805V6.00195H10.998V3.99805H13.002Z"}}]};

const DoubleStoreyFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'double-storey-filled',
    ref,
    icon: element,
  },
));

DoubleStoreyFilledIcon.displayName = 'DoubleStoreyFilledIcon';

export default DoubleStoreyFilledIcon;
